<app-common-header-layout
  [trackingScreenName]="trackingScreenName"
  [trackingObject]="trackingObject$ | async"
>
  <div class="message-container">
    <div class="error-icon-wrapper">
      <i2g-icon class="error-icon" [icon]="errorIcon"> </i2g-icon>
    </div>

    <h1 class="title">
      {{ 'CHANGE_EMAIL.INVALID_TOKEN_TITLE' | translate }}
    </h1>

    <h2 class="sub-title">
      {{ 'CHANGE_EMAIL.INVALID_TOKEN_MESSAGE' | translate }}
    </h2>

    <i2g-router-link
      class="action"
      buttonStyle="emphasis"
      [route]="loginRoute.route"
      [label]="loginRoute.label"
      [trackingObject]="trackingObject$ | async"
      [trackingAction]="loginRoute.trackingAction"
      [alignment]="alignmentEnum.center"
    >
    </i2g-router-link>
  </div>
</app-common-header-layout>
